var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatyaNextMob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 97,
    viewBox: "0 0 467 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0149 58.0099H104.182L99.1436 22.8239H98.0538L93.0149 58.0099ZM109.767 97L106.77 76.2148H90.427L87.4318 97H65.5039L82.5287 0L114.806 0L131.831 97H109.767Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.21 0V22.8239H171.872V97H150.489V22.8239H131.014V0L191.21 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.827 0L266.796 0L242.146 51.8281V97H220.764V51.8281L196.113 0L220.084 0L231.251 30.3634H231.795L242.827 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.269 58.0099H300.438L295.397 22.8239H294.308L289.269 58.0099ZM306.021 97L303.024 76.2148H286.682L283.686 97H261.758L278.783 0L311.06 0L328.084 97H306.021Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.936 97V70.6442L373.3 34.2358V22.0089L373.305 22.8239H357.407L357.365 22.0089V30.976H335.982V13.1772L349.057 0L381.471 0L397.781 13.1772V39.805L362.781 74.7203V72.1309H398.463V97H336.936Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.618 39.5014V39.6696H427.912V22.0089L427.944 21.9773H445.365L445.618 22.0773V39.5014ZM453.789 0L419.741 0L406.531 13.1785V47.6864L419.741 60.8636H445.618V74.9924H429.003V66.0266H407.62V83.8228L420.83 97H453.789L467.001 83.8228V13.1785L453.789 0Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3824 75.4879V60.3667L37.1809 75.4879H21.3824ZM21.3824 21.1532H36.2277L21.3824 36.2731V21.1532ZM42.6863 46.8714L57.4735 33.1869V13.1785L44.3993 0H0V97H45.4877L58.5633 83.8228V61.5668L42.6863 46.8714Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatyaNextMob);
export default __webpack_public_path__ + "static/media/batya_next_mob.a769bafd6e133067722842bc19474c35.svg";
export { ForwardRef as ReactComponent };